import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Box,
  Divider,
  Stack,
} from "@mui/material";

import { Link } from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import ScienceIcon from "@mui/icons-material/Science";
import VerifiedIcon from "@mui/icons-material/Verified";

function PlantCard({ plant }) {
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 5,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #E6ECEF",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        transition: "all .35s ease",

        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 18px 45px rgba(0,0,0,.15)",
        },

        "&:hover img": {
          transform: "scale(1.08)",
        },
      }}
    >
      {/* Image */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <CardMedia
          component="img"
          image={plant.image}
          alt={plant.common_name}
          sx={{
            height: 300,
            objectFit: "cover",
            transition: ".5s",
          }}
        />

        {/* Gradient */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,.55), transparent 45%)",
          }}
        />

        {/* Family */}
        <Chip
          label={plant.family}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            bgcolor: "#2E7D32",
            color: "#fff",
            fontWeight: 700,
          }}
        />

        {/* Plant Name */}
        <Box
          sx={{
            position: "absolute",
            left: 20,
            bottom: 20,
            color: "#fff",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: 28,
            }}
          >
            {plant.common_name}
          </Typography>
        </Box>
      </Box>

      {/* Content */}
      <CardContent
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        <Typography
  mt={1}
  color="#666"
  fontSize={{
    xs: "1rem",
    md: "1.3rem",
  }}
>
  <Typography
    component="span"
    sx={{
      fontStyle: "italic",
    }}
  >
    {plant.scientific_name}
  </Typography>

  {(plant.aname || plant.botanical_profile?.aname) && (
    <Typography
      component="span"
      sx={{
        ml: 0.5,
        fontStyle: "normal",
      }}
    >
      {plant.aname || plant.botanical_profile?.aname}
    </Typography>
  )}
</Typography>

        <Divider sx={{ mb: 2 }} />

        <Stack spacing={2}>
          <Box
            display="flex"
            justifyContent="space-between"
          >
            <Typography
              fontWeight={600}
              color="#0B3C5D"
            >
              Local Name
            </Typography>

            <Typography color="text.secondary">
              {plant.local_name}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
          >
            <Typography
              fontWeight={600}
              color="#0B3C5D"
            >
              Family
            </Typography>

            <Typography color="text.secondary">
              {plant.family}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
          >
            <Typography
              fontWeight={600}
              color="#0B3C5D"
            >
              Conservation
            </Typography>

            <Chip
              size="small"
              icon={<VerifiedIcon />}
              label={plant.conservation_status.iucn_status}
              color="success"
              variant="outlined"
            />
          </Box>
        </Stack>
      </CardContent>

      <CardActions
        sx={{
          px: 3,
          pb: 3,
        }}
      >
        <Button
          fullWidth
          component={Link}
          to={`/digital-flora/${plant.id}`}
          endIcon={<ArrowForwardIcon />}
          variant="contained"
          sx={{
            py: 1.3,
            borderRadius: 10,
            textTransform: "none",
            fontWeight: 700,
            fontSize: 16,
            bgcolor: "#2E7D32",

            "&:hover": {
              bgcolor: "#1B5E20",
            },
          }}
        >
          Explore Botanical Profile
        </Button>
      </CardActions>
    </Card>
  );
}

export default PlantCard;